import { Expose } from "class-transformer";

export default class ModelRange {
	@Expose({ name: "min" })
	private readonly _min: number;
	@Expose({ name: "max" })
	private readonly _max: number;

	constructor(min: number, max: number) {
		this._min = min;
		this._max = max;
	}

	public get min() {
		return this._min;
	}

	public get max() {
		return this._max;
	}
}
